// The four highlight colours, in one place so the Tailwind theme and the app
// code cannot drift apart.
//
// CommonJS because tailwind.config.js requires it at build time; the app side
// imports it through src/constants/highlights.js, which layers the API-enum
// mapping on top. Change a value here and both the `highlight-*` Tailwind
// utilities and the saved-highlight rendering follow.
//
// Pastel by design: light enough that near-black body text stays readable
// through them, distinct enough to tell apart at a glance.
module.exports = {
  yellow: '#FFF1A8',
  green: '#C6E7C8',
  blue: '#C2DEF6',
  pink: '#F7C8DA',
};
